import { Component } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { SeoAuditService } from '../../../services/seo-audit.service';
import BaseComponent from '../BaseComponent';
import Utils from '../../../shared/utils';
import { SeoAuditSummaryFactory } from '../../../factories/seo-audit-summary-factory';
import { SeoAuditSummary } from '../../../shared/models/seo-audits-summary/seo-audits-summary';
import { Statuses } from '../../../shared/models/seo-audits-summary/statuses';

@Component({
    selector: 'app-components-ticket-websiteaudit',
    templateUrl: './website-audit.component.html',
})
export class WebsiteAuditComponent extends BaseComponent {
  reportSummary: SeoAuditSummary;
  isOpen = false;
  additionalInformationTemplate: string;

  Statuses_Fail = Statuses.Fail;
  Statuses_Pass = Statuses.Pass;
  Statuses_Info = Statuses.Info;
  Statuses_Warning = Statuses.Warning;

  constructor(
    private seoAuditService: SeoAuditService,
    private seoAuditSummaryFactory: SeoAuditSummaryFactory,
    private clipboard: Clipboard) {
    super();
  }

  activate(params: app.ticket.components.interfaces.ITicketComponentActivateParams): JQueryPromise<void> {
    return super.activate(params)
        .then(() => {
            return Utils.wrapDfd(this.seoAuditService.getLatest(this.customer.CustomerId()));
        }).then((seoAudit) => {
            if (!seoAudit || !seoAudit.ReportData) {
              return;
            }

            this.reportSummary = this.seoAuditSummaryFactory.Create(seoAudit);
        });
  }

  toggleAdditionalInformation(template?: string) {
    this.additionalInformationTemplate = !template || this.additionalInformationTemplate === template ? '' : template;
  }

  copyAdditionalInformation(additionalInformationKey: string): void {
    switch(additionalInformationKey) {
      case 'Broken Links':
        this.clipboard.copy(JSON.stringify(this.reportSummary.brokenLinks.links, null, 2));
        toastr.success('Broken links copied to clipboard');
        break;
    }
  }
}
